import { useContext } from 'react';

import AppContext from '@/contexts/appContext';
import { createRepository } from '@/repositories/GenericRepository';
import { PhaseType } from '@/types/phaseType';
import { QueryParams } from '@/types/query';

const basePath = '/api/dugout/phase_types';

export const phaseTypeRepository = createRepository<PhaseType, PhaseType>(basePath);

const PhaseTypeRepository = () => {
  const { host } = useContext(AppContext);

  return {
    async list(params: QueryParams = {}) {
      return phaseTypeRepository.listNoPagination({ host, params });
    }
  };
};

export default PhaseTypeRepository;
